import React, { ReactNode } from 'react';

import classNames from 'classnames';
import { motion } from 'framer-motion';

import styles from './styles.module.scss';

type AnimatedTabButton = {
  label: ReactNode;
  icon: ReactNode;
  content: any;
};

export const AnimatedTabButtons = ({
  tabs,
  activeTabIndex,
  onTabClick,
}: {
  tabs: AnimatedTabButton[];
  activeTabIndex: number;
  onTabClick(newIndex: number): void;
}) => {
  return (
    <div className={styles.buttonsWrapper}>
      {tabs.map((tab, index) => (
        <button
          key={tab.label as string}
          className={classNames({ [styles.active]: index === activeTabIndex })}
          onClick={() => onTabClick(index)}
        >
          {activeTabIndex === index && <motion.span layoutId="bubble" className={styles.bubble} />}
          <span className={styles.label}>
            {tab.icon}
            {tab.label}
          </span>
        </button>
      ))}
    </div>
  );
};
